//asc(昇順)|desc(降順)
export type SortOrder = "asc" | "desc";

//ソートのインターフェイス
export interface SortState {
  column: string;
  order: SortOrder;
}

// 2023-04-26T18:37:17.000Z の型を 2023-04-27 に変換
export function formatDate(preDate: string | number | Date): string {
  if (!(preDate instanceof Date) && typeof preDate !== "string" && typeof preDate !== "number") {
    return "";
  }

  const date = new Date(preDate);
  if (isNaN(date.getTime())) {
    return "";
  }

  // 日本時間での年月日を取得
  return date.toLocaleDateString("ja-JP", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).replace(/\//g, "-"); // 日付区切りを "-" に変更
}


export function getIso8601TimeStamp() {
  const now = new Date();
  now.setHours(now.getHours() + 9);
  const isoTimestamp = now.toISOString();
  return isoTimestamp.replace("Z", "+09:00");
}

export const fetchErrorText =
  'エラーが発生しました。システム管理者にお問い合わせください。';
